import { AxiosRequestConfig, AxiosResponse } from 'axios';
import BaseService from './BaseService';

const ApiService = {
  fetchData<T, K = unknown>(param: AxiosRequestConfig<K>) {
    return new Promise<AxiosResponse<T>>((resolve, reject) => {
      BaseService(param)
        .then((response) => {
          resolve(response);
        })
        .catch((errors) => {
          reject(errors);
        });
    });
  },
};

export default ApiService;
